import { render, staticRenderFns } from "./ManagerOrders.vue?vue&type=template&id=44551b71&scoped=true"
import script from "./ManagerOrders.vue?vue&type=script&lang=js"
export * from "./ManagerOrders.vue?vue&type=script&lang=js"
import style0 from "./ManagerOrders.vue?vue&type=style&index=0&id=44551b71&prod&scoped=true&lang=css"
import style1 from "./ManagerOrders.vue?vue&type=style&index=1&id=44551b71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44551b71",
  null
  
)

export default component.exports